module.exports = __webpack_public_path__ + "img/single-shoe.e8fcc119.svg";